import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { useTranslation } from 'react-i18next';

const avatars = {
    Male: 'https://randomuser.me/api/portraits/men/1.jpg',
    Female: 'https://randomuser.me/api/portraits/women/2.jpg',
};

const AvailableParticipants = ({ participants = [], searchTerm = '' }) => {
    const { t } = useTranslation();

    const filteredParticipants = participants.filter((p) =>
        `${p.first_name} ${p.last_name}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    return (
        <div className="lg:w-2/3 w-full bg-white rounded-2xl shadow p-6">
            <h2 className="text-tertiary font-medium text-lg mb-4">
                {t('tent-management-page.Available Participants')}
            </h2>

            <input
                type="text"
                placeholder={`${t('tent-management-page.Search Participants')}`}
                className="mb-4 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchTerm}
                readOnly
            />

            <Droppable droppableId="participants">
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="grid md:grid-cols-2 gap-4 rounded-lg p-1 overflow-auto max-h-[1700px]"
                    >
                        {filteredParticipants.map((p, index) => (
                            <Draggable
                                key={String(p.id)}
                                draggableId={String(p.id)}
                                index={index}
                            >
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="flex items-center gap-4 bg-gray-50 p-4 rounded shadow hover:bg-gray-100 transition"
                                    >
                                        <img
                                            src={
                                                avatars[p.gender] ||
                                                avatars.Male
                                            }
                                            alt={p.first_name}
                                            className="w-12 h-12 rounded-full object-cover border"
                                        />
                                        <div>
                                            <p className="font-medium text-gray-800">
                                                {p.first_name} {p.last_name}
                                            </p>
                                            <p className="text-sm text-gray-500">
                                                {p.gender}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default AvailableParticipants;
